import type { VanityModalState } from './types';

export const mutations = {
	setVanityUrl: (state: VanityModalState, vanityUrl: string): VanityModalState => ({
		...state,
		vanityUrl,
	}),
	setViewState: (state: VanityModalState, viewState: 'CREATE' | 'CONFIRM'): VanityModalState => ({
		...state,
		viewState,
	}),
};
